import { configureStore } from '@reduxjs/toolkit'
import iaamSlice from './iaamSlice'
import dpesSlice from './dpesSlice'
import selectedNodeSlice from './selectedNodeSlice'
import snackbarMessageSlice from './snackbarMessageSlice'
import subjectSchemaSlice from './subjectSchemaSlice'
import clientsSlice from './clientsSlice'
import layoutControlSlice from './layoutControlSlice'
import drgMgtSlice from './drgMgtSlice'
import simulateMgtSlice from './simulateMgtSlice'

export const store = configureStore({
  reducer: {
    layoutControl: layoutControlSlice, // layoutControlSlice 
    drgMgt: drgMgtSlice, // drgMgtSlice
    simulateMgt: simulateMgtSlice, // simulateMgtSlice        
    iaamContext: iaamSlice,
    dpeRedux: dpesSlice,
    selectedNode: selectedNodeSlice,
    snackbarMessage: snackbarMessageSlice,
    subjectSchema: subjectSchemaSlice,
    clients: clientsSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
})